import { useParams } from "react-router";
import { useCommitment } from "@/services/backend/relationships/hooks/use-commitment";
import { WorkOrderData } from "../../../work-orders/[workOrderId]/data/_components/work-order-data";

export function WorkOrderRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: commitment } = useCommitment(relationshipId!, commitmentId!);

  if (!commitment?.documentId) return null;

  return <WorkOrderData workOrderId={commitment.documentId} />;
}
